import { SwitchAccordionProps } from "./types"
import React from "react"
import { Switch } from "~components"
import { useTheme } from '~/ui/styled'
import { Accordion } from "~widgets/accordion"
import styled from '~/ui/styled'

const Wrap = styled.View``

const SwitchAccordion: React.FC<SwitchAccordionProps> = ({ accordionProps, switchProps }) => {
  const theme = useTheme()
  return (
    <Accordion {...accordionProps} hasRightIcon={false}>
      <Wrap>
        <Switch
          {...switchProps}
          trackOnStyle={{
            borderColor: theme.colors.primary,
            backgroundColor: theme.colors.primary,
          }}
        />
      </Wrap>
    </Accordion>
  )
}
export default SwitchAccordion
